import "../../styles/style.css";

export default function CertificateCard({ image, title, onClick }) {
    return (
        <div className="card-swiper">
            <div>

                <img src={image} alt={title} onClick={onClick} />
                
            </div>
        </div>
    );
}